module.exports = __webpack_public_path__ + "img/deep-blue.506c1f3c.png";